import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Navigation",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-nav",
    args: {
        backButtonText: "Back",
    },
    argTypes: {
        backButtonText: {
            control: "string",
        },
    },
};

const Template = ({ backButtonText }) => html`
    <ux-iws-nav back-button-text="${backButtonText}">
        <nav slot="navigation">
            <ul class="ux-iws-nav__lvl1">
                <li class="ux-iws-nav__lvl1-item">
                    <a href="">My Factory</a>
                    <ul class="ux-iws-nav__lvl2">
                        <li class="ux-iws-nav__lvl2-item">
                            <a href="">Machines</a>
                        </li>
                        <li class="ux-iws-nav__lvl2-item">
                            <a href="">Software</a>
                        </li>
                    </ul>
                </li>
                <li class="ux-iws-nav__lvl1-item">
                    <a href="">E-Shop</a>
                    <ul class="ux-iws-nav__lvl2">
                        <li class="ux-iws-nav__lvl2-item">
                            <a href="">Original Parts </a>
                            <div class="ux-iws-nav__lvl3-wrapper">
                                <ul class="ux-iws-nav__lvl3">
                                    <li
                                        class="ux-iws-nav__lvl3-item ux-iws-nav__lvl3-item--overview"
                                    >
                                        <a href="">Startpage</a>
                                    </li>
                                    <li class="ux-iws-nav__lvl3-item">
                                        <a href="">Quick Order</a>
                                    </li>
                                    <li class="ux-iws-nav__lvl3-item">
                                        <a href="">Watch List</a>
                                    </li>
                                    <li class="ux-iws-nav__lvl3-item">
                                        <a href="">Requests & Approvals</a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li class="ux-iws-nav__lvl2-item">
                            <a href="">Bending Tools</a>
                        </li>
                        <li class="ux-iws-nav__lvl2-item">
                            <a href="">Item 1</a>
                        </li>
                        <li class="ux-iws-nav__lvl2-item">
                            <a href="">Item 2</a>
                        </li>
                        <li class="ux-iws-nav__lvl2-item">
                            <a href="">Item 3</a>
                        </li>
                        <li class="ux-iws-nav__lvl2-item">
                            <a href="">Item 4</a>
                        </li>
                    </ul>
                </li>
                <li class="ux-iws-nav__lvl1-item">
                    <a href="">Service</a>
                    <ul class="ux-iws-nav__lvl2">
                        <li class="ux-iws-nav__lvl2-item">
                            <a href="">My Service Cases</a>
                        </li>
                        <li class="ux-iws-nav__lvl2-item">
                            <a href="">Download Center</a>
                        </li>
                    </ul>
                </li>
                <li class="ux-iws-nav__lvl1-item">
                    <a href="">Knowledge</a>
                    <ul class="ux-iws-nav__lvl2">
                        <li class="ux-iws-nav__lvl2-item">
                            <a href="">Trainings</a>
                        </li>
                        <li class="ux-iws-nav__lvl2-item">
                            <a href="">Know How</a>
                        </li>
                        <li class="ux-iws-nav__lvl2-item">
                            <a href="">FAQ</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
        <div slot="navigation-meta" class="ux-iws-nav__meta">
            <div class="ux-iws-nav__meta-container-header">
                <ux-iws-navigation-meta>
                    <div
                        class="ux-iws-navigation-meta__item ux-iws-navigation-meta__item--mobile-visible"
                    >
                        <div class="ux-iws-navigation-meta__search">
                            <ux-icon name="nav-search"></ux-icon>
                            <span class="ux-iws-navigation-meta__link-text"
                                >Search</span
                            >
                            <form
                                class="ux-iws-navigation-meta__search__form"
                                action="/no_cache/de_DE/meta/suche/"
                            >
                                <input
                                    type="search"
                                    name="q"
                                    class="ux-iws-navigation-meta__search__input"
                                    placeholder="Suche"
                                    tabindex="0"
                                    autocomplete="off"
                                />
                                <button
                                    type="button"
                                    class="ux-iws-navigation-meta__search__close"
                                    tabindex="0"
                                >
                                    <ux-icon name="close"></ux-icon>
                                </button>
                            </form>
                        </div>
                    </div>
                    <div class="ux-iws-navigation-meta__item">
                        <a href="#">
                            <span class="ux-iws-navigation-meta__icon-box">
                                <ux-icon name="nav-contact"></ux-icon>
                            </span>
                            <span class="ux-iws-navigation-meta__link-text"
                                >Kontakt</span
                            >
                        </a>
                    </div>
                    <ux-iws-async-html
                        class="ux-iws-navigation-meta__item"
                        data-src="./mock-data/navigation/navigation-async-html-cart.html"
                    ></ux-iws-async-html>
                    <ux-iws-async-html
                        class="ux-iws-navigation-meta__item"
                        data-src="./mock-data/navigation/navigation-async-html-profile.html"
                    ></ux-iws-async-html>
                    <div
                        class="ux-iws-navigation-meta__item ux-iws-navigation-meta__item--disabled"
                    >
                        <span class="ux-iws-navigation-meta__icon-box">
                            <ux-icon name="nav-globe"></ux-icon>
                        </span>
                        <span class="ux-iws-navigation-meta__link-text"
                            >Deutschland | DE</span
                        >
                    </div>
                    <div
                        class="ux-iws-navigation-meta__item ux-iws-navigation-meta__item--top-border"
                    >
                        <a href="#">
                            <span class="ux-iws-navigation-meta__icon-box">
                                <ux-icon name="nav-home"></ux-icon>
                            </span>
                            <span class="ux-iws-navigation-meta__link-text"
                                >GO to mytrumpf</span
                            >
                        </a>
                    </div>
                </ux-iws-navigation-meta>
            </div>
            <div class="ux-iws-nav__meta-container-burger">
                <ux-iws-nav-burger
                    menu-text-open="Menü"
                    menu-text-close="Schliessen"
                ></ux-iws-nav-burger>
            </div>
        </div>
    </ux-iws-nav>
`;

export const Default = Template.bind({});
Default.args = {
    backButtonText: "Back",
};
